/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { LEGACY_TAB_REDIRECTS, RECONCILIATION_PATH, tabSearch } from '@/modules/reconciliation/route';

// S29: a aba por caminho do legado (router.tsx:789-823) vira `?tab=` na tela `/concilicao`.
export const Route = createFileRoute('/_app/concilicao/fgts/')({
  beforeLoad: () => {
    throw redirect({ to: RECONCILIATION_PATH, search: tabSearch(LEGACY_TAB_REDIRECTS['/concilicao/fgts'] ?? 'fgts'), replace: true });
  },
});
